module.exports = __webpack_public_path__ + "img/product16.36e37a3d.jpg";